import { render, staticRenderFns } from "./CountriesPreview.vue?vue&type=template&id=2a656952&"
import script from "./CountriesPreview.vue?vue&type=script&lang=js&"
export * from "./CountriesPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports